import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFacepunchComponent } from './simple-icons-facepunch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFacepunchComponent ],
    exports:      [ SimpleIconsFacepunchComponent ],
    bootstrap:    []
})
export class SimpleIconsFacepunchModule {}
